module.exports = __webpack_public_path__ + "img/MDI-calendar-remove.fad89727.svg";